'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SpectoTastingCheckout = null;

var TastingCheckout = function () {
    function TastingCheckout() {
        _classCallCheck(this, TastingCheckout);

        this.variables();
        this.cacheDOM();
        this.bindEvents();
        this.onLoad();
    }

    _createClass(TastingCheckout, [{
        key: 'variables',
        value: function variables() {
            this.selectedTimes;
            this.selectedTerm;
            this.showReloadAlert = false;
            this.cartData = [];
            this.stockNum = 100;
            this.minimumStock = 1;
            this.isMobile = false;
        }
    }, {
        key: 'cacheDOM',
        value: function cacheDOM() {
            this.tourBox = '.tour-box.price';
            this.timeSelect = '#time-select';
            this.$datePicker = $('#package-date');
            this.$dateinput = $('#date-input-value');
            this.$datesData = $('#packet-data');
            this.avaliableDates = this.$datesData.data('datesOk');
            this.$timeSelect = $(this.timeSelect);
            this.$formStep1 = $('#checkout-step-1');
        }
    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            $(document).on('change', this.timeSelect, this.changeTimeDropdown.bind(this));
            $(document).on('click', '.command', this.quantityChange.bind(this));
            $(document).on('click', '#btn-step1-submit', this.step1Submit.bind(this));
            $(document).on('click', '#step2-previous', this.showPrevious.bind(this));
            $(document).on('click', '#step2-pay', this.completePayment.bind(this));
            $(document).on('click', '.check-coupon', this.checkCoupon.bind(this));
        }
    }, {
        key: 'onLoad',
        value: function onLoad() {
            Cookies.remove('customer_hash'); // always remove customer_hash because in single page checkout
            this.initDatePicker();
            if (!$('.tickets').data('isMobile')) {
                this.$formStep1.validate({
                    rules: {
                        phone: {
                            required: true,
                            minlength: 8
                        }
                    }
                });
            }
            if ($('.tickets').data('isMobile')) {
                this.minimumStock = 0;
                this.isMobile = true;
            }
        }
    }, {
        key: 'checkCoupon',
        value: function checkCoupon(e) {
            var _this = this;

            e.preventDefault();
            var value = $('#coupon-code').val();
            var pResponse = $('#coupon-response');
            $('.loader-wrapper ').show();
            $.ajax({
                method: 'POST',
                url: window.location.origin + '/api/v1/shop/cart/check-coupon',
                data: { value: value }
            }).done(function (res) {
                $('.loader-wrapper ').hide();
                if (res.is_ok) {
                    pResponse.html(pResponse.data('success') + ' (' + value + ')').removeClass().addClass('success');
                    var newPrice = res.sum_price.toString().replace(',', '.');
                    $('.summary-total b').html(newPrice);
                    $(e.currentTarget).hide();
                    $('#coupon-code').hide();
                    if (res.id === 1) {
                        _this.customOrderCheck();
                    }
                } else {
                    pResponse.html(pResponse.data('error')).removeClass().addClass('error');
                }
            }).error(function (err) {
                $('.loader-wrapper ').hide();
            });
        }
    }, {
        key: 'customOrderCheck',
        value: function customOrderCheck() {
            var orderData = this.getOrderData();
            orderData.cartData = this.cartData;
            // fix for ordercontroller
            orderData.post_code = 2000;
            orderData.lang = $('html').attr('lang');
            var params = $.param(orderData);
            $('.loader-wrapper').show();
            $.ajax({
                method: 'POST',
                url: window.location.origin + '/api/v1/tasting/custom-order',
                data: { order_data: params },
                success: function success(res) {
                    Cookies.remove('customer_hash');
                    $('.loader-wrapper').hide();
                    window.location.href = '/';
                },
                error: function error(_error) {
                    $('.loader-wrapper').hide();
                    alert(_error.responseJSON.data);
                }
            });
        }
    }, {
        key: 'showPrevious',
        value: function showPrevious(e) {
            e.preventDefault();
            $('.form-step-2').hide();
            $('.form-step-1').show();
            $('html, body').animate({
                scrollTop: $($('.book-now-wrap')).offset().top
            }, 500);
        }
    }, {
        key: 'resetPrices',
        value: function resetPrices() {
            $('.choose-tickets').find('.numbers-value').html("0");
            $('.tickets-price span').html("0 €");
            $('.total-price span b').html("0");
        }
    }, {
        key: 'quantityChange',
        value: function quantityChange(e) {
            var elm = $(e.target);

            var qInput = elm.parent().find('.numbers-value');
            var price = qInput.data('price');

            var currentVal = Number(qInput.html());
            var allStock = 0;
            $('.choose-tickets').find('.numbers-value').each(function () {
                allStock += Number($(this).html());
            });
            if (elm.hasClass('minus') && currentVal > 0) {
                currentVal--;
                allStock--;
            } else if (elm.hasClass('plus') && allStock < this.stockNum) {
                currentVal++;
                allStock++;
            }
            qInput.html(currentVal);
            // calc price
            elm.parent().parent().find('.tickets-price span').html(currentVal * price + " €");
            var sumPrice = 0;
            $('.choose-tickets').find('.tickets-price span').each(function () {
                sumPrice += parseFloat($(this).html());
            });

            $('.total-price span b').html(sumPrice);

            if (allStock > this.minimumStock) {
                this.$formStep1.show();
            } else {
                this.$formStep1.hide();
            }
        }
    }, {
        key: 'changeTimeDropdown',
        value: function changeTimeDropdown(e) {
            var elm = $(e.target);
            this.selectedTerm = this.selectedTimes[elm.val()];
            this.stockNum = this.selectedTerm.stock;
            this.resetPrices();
        }
    }, {
        key: 'initDatePicker',
        value: function initDatePicker() {
            var that = this;
            var disabledDates = this.$datesData.data('emptyDates'); //['2018.8.27', '2018.8.28'];
            var tomorrow = new Date();
            var maxDate = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            maxDate.setFullYear(this.$datesData.data('maxYear'), this.$datesData.data('maxMonth'), this.$datesData.data('maxDay'));
            this.$datePicker.datepicker({
                timepicker: false,
                minDate: tomorrow,
                maxDate: maxDate,
                toggleSelected: false,
                onSelect: function onSelect(fd, d, picker) {
                    $('.tickets').show();
                    that.$dateinput.val(that.getFormattedDate(d, 'input'));
                    that.renderTimeDropdown(that.getFormattedDate(d, 'calendar'));
                    that.showReloadAlert = true;
                },
                onRenderCell: function onRenderCell(d, type) {
                    if (type === 'day') {
                        var disabled = false,
                            formatted = that.getFormattedDate(d);
                        disabled = disabledDates.filter(function (date) {
                            return date == formatted;
                        }).length;

                        return {
                            disabled: disabled
                        };
                    }
                }
            });
        }
    }, {
        key: 'getFormattedDate',
        value: function getFormattedDate(date) {
            var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            if (type === 'checkout') {
                var tmp = date.split('/');
                return tmp[1] + "." + tmp[0] + "." + tmp[2];
            }
            var year = date.getFullYear(),
                month = date.getMonth() + 1,
                day = date.getDate();
            if (type === 'input') {
                return day + ' / ' + month + ' / ' + year;
            } else if (type === 'calendar') {
                return day + '.' + month + '.' + year;
            } else {
                return year + '.' + month + '.' + day;
            }
        }
    }, {
        key: 'renderTimeDropdown',
        value: function renderTimeDropdown(date) {
            this.resetPrices();
            this.selectedTimes = this.avaliableDates[date];
            if (this.selectedTimes.length > 0) {
                this.selectedTerm = this.selectedTimes[0];
                var faker = $(".pick-time-cont .faker");
                var newarr = [];
                $.each(this.selectedTimes, function (i, item) {
                    var itm = {};
                    itm.idx = i;
                    itm.hour = item.hour + " (" + item.stock + ")";
                    newarr.push(itm);
                });
                specto_faker.updateOptions(faker, newarr, "idx", "hour", {});
            }
        }
    }, {
        key: 'step1Submit',
        value: function step1Submit(e) {
            e.preventDefault();

            if (this.$formStep1.valid()) {
                this.prepareStep2();
                this.addToCartPrepareStep();
            }
        }
    }, {
        key: 'prepareStep2',
        value: function prepareStep2() {
            this.cartData = [];
            if (!this.isMobile) {
                $('#checkout-date span').html(this.getFormattedDate(this.$datePicker.val(), 'checkout')); // set date
                $('#checkout-time span').html(this.selectedTerm.hour); // set time
            } else {
                $('#checkout-date span').html('valid 1 year');
                $('#checkout-time span').html('/');
            }
            // set payment method
            $('#checkout-payment-type span').html(this.getPaymentType());
            //$('#checkout-payment-type span').html($('input[name=payment_method]:checked').val());
            $('#checkout-payment-type span').html($('input[name=payment_method]:checked').data('paymentName'));

            var summaryHtml = '';
            var that = this;
            $('.single-category').each(function () {
                var quantity = $(this).find('.numbers-value').html();
                if (quantity > 0) {
                    var price = $(this).find('.numbers-value').data('price');
                    var title = $(this).find('.ticket-desc span').html();
                    var item = {};
                    var attr = [];
                    item.product_id = $('.package-name').data('productId');
                    item.quantity = quantity;
                    if (!that.isMobile) {
                        attr.push(that.selectedTerm.attr_id);
                    }
                    attr.push($(this).find('.numbers-value').data('attrId'));
                    item.attributes = attr;
                    item.price = price;
                    item.title = title;

                    summaryHtml += '\n                    <div>\n                    <div class="label">\n                        <span>' + title + '</span>\n                    </div>\n                    <div class="value">\n                        <span>' + quantity + ' x ' + price + ' \u20AC</span>\n                    </div>\n                    </div>';
                    that.cartData.push(item);
                }
            });
            $('.summary-tickets').html(summaryHtml);
            // total price
            $('.summary-total b').html($('.total-price span b').html());

            // coupon fields reinit
            $('#coupon-code').val('').show();
            $('.check-coupon').show();
            $('#coupon-response').html('');
        }
    }, {
        key: 'addToCartPrepareStep',
        value: function addToCartPrepareStep() {
            var that = this;
            var orderData = this.getOrderData();
            orderData.cartData = this.cartData;
            // cart hash generation
            var hash = "";
            if (typeof Cookies.get('customer_hash') !== 'undefined') {
                hash = Cookies.get('customer_hash');
            } else {
                hash = $('#ord_hash').val();
                Cookies.set("customer_hash", hash, { expires: 14 });
            }
            var params = [];
            $.each(orderData.cartData, function (key, item) {
                params.push({ product_id: item.product_id, quantity: item.quantity, hash: hash, type: 'edit', attributes: JSON.stringify(item.attributes) });
            });

            $('.loader-wrapper').show();
            $.ajax({
                method: 'POST',
                url: window.location.origin + '/api/v1/shop/cart/add-to-cart-multiple',
                data: { cart_data: params, hash: hash, clear_coupon: true },
                success: function success(res) {
                    $('.loader-wrapper ').hide();
                    if (res.is_ok) {
                        $('.form-step-1').hide();
                        $('.form-step-2').show();
                        $('html, body').animate({
                            scrollTop: $($('.book-now-wrap')).offset().top
                        }, 500);
                    } else {
                        that.showErrorWithText(res.msg);
                    }
                },
                error: function error(_error2) {
                    that.showErrorWithText(_error2.msg);
                }
            });
        }
    }, {
        key: 'completePayment',
        value: function completePayment(e) {
            e.preventDefault();
            var that = this;
            if ($('#terms').prop('checked')) {
                // show loader
                $('.loader-wrapper ').show();

                var orderData = this.getOrderData();
                orderData.cartData = this.cartData;
                // cart hash generation
                var hash = "";
                if (typeof Cookies.get('customer_hash') !== 'undefined') {
                    hash = Cookies.get('customer_hash');
                } else {
                    hash = $('#ord_hash').val();
                    Cookies.set("customer_hash", hash, { expires: 14 });
                }

                // fix for ordercontroller
                orderData.post_code = 2000;
                orderData.lang = $('html').attr('lang');
                var params = $.param(orderData);

                $.ajax({
                    method: 'POST',
                    url: window.location.origin + '/api/v1/shop/create-order',
                    data: { data: params },
                    success: function success(res) {
                        if (res.is_ok) {
                            var redirectUrl = res.url;
                            if (parseInt(res.paymentType) === 2) {
                                document.cookie = 'customer_hash=; Max-Age=0';
                                redirectUrl = $('#proforma_url').val() + '?transaction-hash=' + hash;
                            }
                            if (!!res.delete_cookie) {
                                document.cookie = 'customer_hash=; Max-Age=0';
                            }
                            SpectoTastingCheckout.showReloadAlert = false;
                            window.location.href = redirectUrl;
                        } else {
                            Cookies.remove('customer_hash');
                            $('.loader-wrapper ').hide();
                            window.location.href = res.url;
                        }
                    },
                    error: function error(err) {
                        //that.showErrorWithText(err.responseJSON.msg);
                        $('.loader-wrapper ').hide();
                    }
                });
            } else {
                that.showErrorWithText("You must agree to the terms and services.");
            }
        }
    }, {
        key: 'showErrorWithText',
        value: function showErrorWithText(txt) {
            alert(txt);
        }
    }, {
        key: 'getPaymentType',
        value: function getPaymentType() {
            return $('input[name=payment_method]:checked').val();
        }
    }, {
        key: 'getOrderData',
        value: function getOrderData() {
            var order = {};
            var date = $('#checkout-date span').text();
            var hour = $('#checkout-time span').text();
            var hash = $('#ord_hash').val();
            order.first_name = $('#name').val();
            order.email = $('#email').val();
            order.phone = $('#phone').val();
            order.is_newsletter = $('#newsletter').prop('checked') ? true : false;

            order.rbtn_payment_type = this.getPaymentType(); //1; // dynamically change (type of payment)
            order.rbtn_shipping = 1; // fake free shipping
            var special = {};
            if ($('#allergies').val() !== '') {
                special.allergies = $('#allergies').val();
            }
            if ($('#alt-dates').val() !== '') {
                special.alternative_dates = $('#alt-dates').val();
            }
            if ($('#special-wishes').val() !== '') {
                special.special_wishes = $('#special-wishes').val();
            }
            if ($('#age').val() !== '') {
                special.age = $('#age').val();
            }
            if ($('#sel_language').val() !== '') {
                special.language = $('#sel_language').val();
            }
            if ($('#is_mobile').val() !== 1) {
                special.is_mobile = $('#is_mobile').val();
            }
            // custom subject form TM
            special.custom_subject = date + ' - ' + hour + ' (' + hash + ')';
            order.special = special;

            return order;
        }
    }]);

    return TastingCheckout;
}();

$(document).ready(function () {
    SpectoTastingCheckout = new TastingCheckout();
});

window.onbeforeunload = function () {
    if (SpectoTastingCheckout.showReloadAlert) {
        return "Data will be lost if you leave the page, are you sure?";
    }
};